<template>
    <pop-up :closable="closable" @close="close">
        <div >
            <div class="text-white">
                <h2 class="text-2xl text-white mb-5">
                    Passcode Protected
                </h2>

                <div class="mb-5">
                    <p class="mb-1">
                        Please enter the passcode provided with this machine.
                    </p>
                </div>

                <div class="flex">
                    <div class="input-container input-container--floating relative md:w-64 "
                         :class="{empty: !passcode}">
                        <input
                                id="passcode"
                                type="text"
                                v-model="passcode"
                                @keyup.enter="doSubmit"
                                class="h-full w-full border-gray-300 px-2 transition-all border-blue-gray rounded text-blue "
                        />
                        <label for="passcode" class="absolute left-2 transition-all px-1 text-blue-gray ">
                            Passcode
                        </label>

                        <span class="absolute flex items-center text-2xl" :class="{hidden: !loading }" style="right: 9px;top: calc(50% - 10px);">
                            <i class="fas fa-spinner fa-spin text-black"></i>
                        </span>
                    </div>

                    <button type="submit" class="btn ml-4" @click="doSubmit" >Verify</button>

                </div>

                <div v-if="passcodeFailCounter" class="bg-red text-white mt-5 px-3 py-2 rounded ">
                    <span v-if="remainingAttempts >= 2">
                        Wrong passcode, {{ remainingAttempts }} attempts remaining
                    </span>
                    <span v-if="remainingAttempts == 1">
                        Wrong passcode, {{ remainingAttempts }} attempt remaining
                    </span>
                    <span v-if="remainingAttempts == 0">
                        Wrong passcode, 0 attempts remaining, you may try again in 5 minutes
                    </span>
                </div>
            </div>

        </div>
    </pop-up>
</template>

<script charset="utf-8">

import PopUp from '../includes/PopUp.vue';
import { parseEquipment } from '../../service/parser'
import Vuex from 'vuex';

export default {
    props: {
        machineID: {
            default: true
        },
        serial: {
            default: true
        },
        closable: {
            default: true
        }
    },

    data() {
        return {
            loading: false,
            submittedOnce: false,
            passcode: '',
            errorMessage: 'Please enter the passcode'
        }
    },


    computed: {
        ...Vuex.mapGetters('profile', {
            onPasscodePenalty: 'onPasscodePenalty',
            passcodeFailCounter: 'passcodeFailCounter',
        }),
        remainingAttempts() {
            return 3 - this.passcodeFailCounter;
        },
    },

    components: {
        PopUp
    },


    watch: {
        passcode: {
            handler(value){
                this.errorMessage = this.passcode ? '' : 'Please enter the passcode';
            },
        }
    },

    emits: ['submit', 'close', 'submit-success'],

    methods: {
        ...Vuex.mapMutations('layout', {
            setShowPopUp: 'setShowPopUp'
        }),

        ...Vuex.mapMutations('profile', {
            increasePasscodeFailCounter: 'increasePasscodeFailCounter',
            resetPasscodeFailCounter: 'resetPasscodeFailCounter',
            loginEquipment: 'loginEquipment',
        }),

        ...Vuex.mapActions('equipments', {
            autoLogin: 'autoLogin',
            clearCurrentItem: 'clearCurrentItem',
        }),

        doSubmit(){
            this.submittedOnce = true;
            if(this.errorMessage){
                return;
            }

            if(this.onPasscodePenalty){
                return;
            }

            this.$emit('submit');

            let data = {
                war_id: this.machineID,
                serial: this.serial,
                passcode: this.passcode
            };

            this.loading = true;

            return this.autoLogin(data).then(res => {
                if(res.has_passcode){
                    this.setShowPopUp(true);
                }else{
                    this.setShowPopUp(false);
                    this.resetPasscodeFailCounter();
                    this.loginEquipment(parseEquipment(res));
                    if( this.$route.name == 'autologin'){
                        this.$router.push({ path: 'autologin', query: { war_id: data.war_id, serial: data.serial ? data.serial : data.partial_serial }});
                    }
                    this.$emit('submit-success');
                }
            }).catch(() => {
                this.errors = {
                    message: 'Invalid Data'
                };
                this.increasePasscodeFailCounter();

            }).finally(() => {
                this.loading = false;
            });
        },
        close(){
            this.$emit('close');
        }
    }

}
</script>
